/**
 * getRandomBrightColor — returns a random hex color guaranteed to be "bright"
 * (the three channels sum to at least 400).
 *
 * This lives in its OWN module, deliberately, and must stay dependency-free.
 *
 * Why: `src/redux/reducers/colorPalette.js` calls it at module scope to seed
 * its initialState. It used to import it from the `src/utils/helpers.js`
 * barrel, which transitively pulls in the whole component tree
 * (constants/segmentTools -> CodeBlocks -> ... -> Navbar -> src/redux/index.js)
 * and therefore back into `src/redux/reducers/index.js`. That import cycle made
 * `rootReducer` undefined whenever the reducer tree was the entry module, which
 * crashed `createStore` with "baseReducer is not a function" — see
 * src/redux/reducers/logout.test.js.
 *
 * Keep this file free of imports so the reducer layer never reaches the
 * component layer again.
 */
export function getRandomBrightColor() {
  let r, g, b;

  // Ensure bright colors by keeping at least one channel high
  do {
    r = Math.floor(Math.random() * 256);
    g = Math.floor(Math.random() * 256);
    b = Math.floor(Math.random() * 256);
  } while (r + g + b < 400); // Ensures brightness

  return `#${r.toString(16).padStart(2, "0")}${g
    .toString(16)
    .padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
}

export default getRandomBrightColor;
